export default __webpack_public_path__ + "static/media/girl-reading.b91ee23e.png";